module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"yLabel":"Kapital (CHF)","balance":"Kapitalentwicklung","types":{"subsidies":"Einmalvergütung","operation_costs":"Betriebskosten","revenue_ownuse":"Reduktion Netzbezug","revenue_feedin":"Rückspeisung","investment":"Investitionskosten"}}}')
  delete Component.options._Ctor
}
